import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { NzTreeNodeOptions } from "ng-zorro-antd/tree";
import { HTTPService } from "src/app/services/http.service";
import { MenuServices } from "src/app/services/menu-service.services";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { NavItem } from "src/app/interfaces/nav-item";
import { AcessUser } from "../acess-view.component";

@Component({
    selector: "app-menu-view",
    templateUrl: "./menu-view.component.html",
    styleUrls: ["./menu-view.component.scss"],
    standalone: false
})
export class MenuViewComponent implements OnChanges {

  @Input() user: AcessUser;

  navItems: NavItem[] = [];
  nodes: NzTreeNodeOptions[] = [];
  searchValue: string = "";
  loading: boolean = false;

  /** permissão de visualização do usuário selecionado, por nuMenu */
  menuAllowed: { [nuMenu: string]: boolean } = {};
  /** menus que o usuário LOGADO pode conceder (só concede o que enxerga) */
  private menuGrantable: { [nuMenu: string]: boolean } = {};
  private keySeq: number = 0;

  constructor(
    private http: HTTPService,
    private MenuServices: MenuServices,
    private uas: UserAuthenticationServices
  ) {
    this.navItems = JSON.parse(JSON.stringify(MenuServices.navItems));
    this.nodes = this.buildNodes(this.navItems);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user != null && this.user != null) {
      this.loadMenuAcess();
    }
  }

  private buildNodes(items: NavItem[]): NzTreeNodeOptions[] {
    if (items == null) {
      return [];
    }

    return items.map((item) => {
      let children = this.buildNodes(item.children);
      return {
        title: item.displayName,
        key: "menu-" + (this.keySeq++),
        expanded: false,
        children: children,
        isLeaf: children.length == 0,
        navItem: item
      };
    });
  }

  loadMenuAcess() {
    this.loading = true;
    this.menuAllowed = {};
    this.menuGrantable = {};

    let logged = this.uas.user;
    let ids = String(this.user.id);
    if (logged.profile != "ADMIN" && String(logged.iduser) != ids) {
      ids += "," + logged.iduser;
    }

    let ob = {
      entityName: "Mktpmenu",
      sql: `SELECT IDUSER, NUMENU, CANVIEW FROM MKTPMENUACESS WHERE IDUSER IN (${ids})`
    };

    this.http.post(ob, "JsonBrokerServices/findnative", false, true, true).subscribe((con) => {
      let rows: Object[] = con["SQL"] != null ? con["SQL"] : [];

      rows.forEach((r) => {
        let can = r["CANVIEW"] == "S";
        if (String(r["IDUSER"]) == String(this.user.id)) {
          this.menuAllowed[r["NUMENU"]] = can;
        }
        if (String(r["IDUSER"]) == String(logged.iduser)) {
          this.menuGrantable[r["NUMENU"]] = can;
        }
      });

      this.loading = false;
    }, (error) => {
      this.loading = false;
      throw error;
    });
  }

  canGrant(nuMenu: any): boolean {
    if (this.uas.user.profile == "ADMIN") {
      return true;
    }
    return this.menuGrantable[nuMenu] === true;
  }

  toggleMenu(nuMenu: any, checked: boolean) {
    this.menuAllowed[nuMenu] = checked;

    let jsonSave: Object = {
      entityName: "Mktpmenuacess",
      IDUSER: this.user.id,
      NUMENU: nuMenu,
      CANVIEW: checked ? "S" : "N",
    };

    this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe();
  }
}
